
import { defineComponent, computed } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "from-validate",
  props: {
    to: {
      type: String,
    },
  },
  setup(props) {
    const route = useRoute();
    const isActive = computed(() => {
      return route.hash === props.to ? "active" : false;
    });
    return {
      isActive,
    };
  },
});
